import BurgerMenuIcon from "~/icons/BurgerMenuIcon";

import styles from "./Header.module.css";
import { useContext } from "react";
import ThemeContext from "~/contexts/ThemeContext";
import { getLuma } from "~/helpers/colorHelpers";
import { CartPosition } from "~/entities/templateEntities";
import { useLocation } from "@remix-run/react";
import { Menu, MenuShort } from "~/entities/menuEntities";
import { Site } from "~/entities/siteEntities";
import { uploadcareConfig } from "~/configs/uploadcareConfig";
import CartDropdown from "~/modules/cart/components/CartDropdown/CartDropdown";

type HeaderProps = {
  site?: Site;
  menus?: MenuShort[];
  menu?: Menu | null;
  openAuthDialog: VoidFunction;
  openMenuBar: VoidFunction;
};

const Header: React.FC<HeaderProps> = ({ site, openMenuBar }) => {
  const { template } = useContext(ThemeContext);

  const location = useLocation();

  // Styles
  // Header
  const headerBackgroundColor = template.navBar.backgroundColour;
  const headerBorderColor = template.navBar.borderColour;
  const logo = template.navBar.logo;
  const fontColor = getLuma(headerBackgroundColor) < 150 ? "#fff" : "#000";

  const hideCartDropdown =
    ["/checkout", "/payment", "/declined", "/success"].some((path) =>
      location.pathname.split("?")[0].endsWith(path)
    ) || template.cart.position !== CartPosition.AtTheTopRightCorner;

  return (
    <div
      data-sticky="header"
      className={styles.wrapper}
      style={{
        backgroundColor: headerBackgroundColor,
        borderColor: headerBorderColor,
      }}
    >
      <div className={styles.innerWrapper}>
        <div className={styles.menuWrapper}>
          <div
            data-selector="header-burger-menu"
            className={styles.burgerMenuIcon}
            onClick={openMenuBar}
          >
            <BurgerMenuIcon color={fontColor} />
          </div>
        </div>

        {logo && (
          <div className={styles.logoWrapper}>
            <img
              className={styles.image}
              src={uploadcareConfig.getUrl(logo.fileId, logo.modifiers)}
              alt={logo.fileName}
            />
          </div>
        )}

        <div className={styles.cartWrapper}>
          {!hideCartDropdown && site && (
            <div className={styles.cart}>
              <CartDropdown />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
